import GrillaPagoSinFactura from "../../moleculas/GrillaPagoSinFactura/GrillaPagoSinFactura"

function GrillaPagosSinFacturaContainer() {
  return (
    <div> 
      <GrillaPagoSinFactura/>
    </div>
  )
}

export default GrillaPagosSinFacturaContainer
